import { serviceDeskIncomingEmailResource } from '@jira/router-resources__service-desk-incoming-email/src/index.tsx';
import { csmHubSetupResource } from '@jira/router-resources__customer-service-project-properties/src/index.tsx';

import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsDetailsRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsDetailsRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { navigation } from './common/constants.tsx';
import { helpCenterSettingDetailsAppPageEntryPoint } from './ui/details/index.tsx';

export const helpCenterSettingsDetailsRouteEntry = createEntry(
	helpCenterSettingsDetailsRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.details',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint() {
			return helpCenterSettingDetailsAppPageEntryPoint;
		},

		resources: [
			...getServiceDeskSettingsResources(),
			resourceWithCondition2(() => fg('csm-onboarding'), serviceDeskIncomingEmailResource),
			resourceWithCondition2(() => fg('csm-onboarding'), csmHubSetupResource),
		],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsDetailsRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsDetailsRouteEntry',
			},

			enabled: true,
		},
	}),
);
